import { QueryParams } from '../../../core/Http/QueryParams';
import { Response } from '../../../core/Http/RestResponse';
import { apiSlice, apiParams } from '../../../store/Api';
import { Order, OrderLine } from '../../Orders/Types';

export const shoppingCartApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getShoppingCartOrderLines: builder.query<Response<OrderLine[]>, { orderId: string; params?: QueryParams }>({
      query: ({ orderId, params }) => ({
        url: apiParams.paths.orderLines,
        params: { ...params, orderId },
      }),
      providesTags: [apiParams.tags.shoppingCart],
    }),
    getShoppingCartInfo: builder.query<Order, void | null>({
      query: () => ({
        url: apiParams.paths.orders,
        method: apiParams.methods.POST,
      }),
      providesTags: [apiParams.tags.shoppingCart],
    }),
    addPartToShoppingCart: builder.mutation<OrderLine, { partId: string; numberOfParts: number }>({
      query: ({ partId, numberOfParts }) => ({
        url: apiParams.paths.orderLines,
        method: apiParams.methods.POST,
        body: {
          partId,
          numberOfParts,
        },
      }),
      invalidatesTags: [apiParams.tags.shoppingCart],
    }),
    emptyShoppingCart: builder.mutation<void, void>({
      query: () => ({
        url: apiParams.paths.orderLines,
        method: apiParams.methods.DELETE,
      }),
      invalidatesTags: [apiParams.tags.shoppingCart],
    }),
    updateOrderLine: builder.mutation<OrderLine, { id: string; numberOfParts: number }>({
      query: ({ id, numberOfParts }) => ({
        url: `${apiParams.paths.orderLines}/${id}`,
        method: apiParams.methods.PATCH,
        body: { numberOfParts },
      }),
      invalidatesTags: [apiParams.tags.shoppingCart],
    }),
    deleteOrderLine: builder.mutation<OrderLine, OrderLine>({
      query: ({ id }) => ({
        url: `${apiParams.paths.orderLines}/${id}`,
        method: apiParams.methods.DELETE,
      }),
      transformResponse: (_res, _meta, orderLine) => orderLine,
      invalidatesTags: [apiParams.tags.shoppingCart],
    }),
  }),
});

export const {
  useLazyGetShoppingCartOrderLinesQuery,
  useGetShoppingCartOrderLinesQuery,
  useGetShoppingCartInfoQuery,
  useUpdateOrderLineMutation,
  useDeleteOrderLineMutation,
  useAddPartToShoppingCartMutation,
  useEmptyShoppingCartMutation,
} = shoppingCartApiSlice;
